module.exports = __webpack_public_path__ + "media/images/people-commenting-2ce22aef7509d9fb26a4f2863958afd8.svg";